// document.addEventListener("DOMContentLoaded", () => {
//   const productQuantity = document.querySelector("[data-js-product-quantity]");
//   const variantInputs = document.querySelectorAll(".product-variant__input");
//   const qty = productQuantity.querySelector(".qty-selector");
//   const qtyMinus = productQuantity.querySelector(".qty-minus"); // Minus button
//   const qtyPlus = productQuantity.querySelector(".qty-plus");
//   const priceElement = document.querySelector(".product-price--original");
//   const quantityButtons = document.querySelector(".product-quantity");

//   const hasUnitsPerPallet = document.querySelector(
//     ".product-variant__input[data-units-per-pallet]"
//   );

//   if (!hasUnitsPerPallet) {
//     console.log(
//       "Units per pallet metafield not found, skipping quantity logic."
//     );
//     return;
//   }

//   const getNumberOfPallets = () => {
//     const selectedVariant = document.querySelector(
//       ".product-variant__input:checked"
//     );
//     if (selectedVariant) {
//       let palletValue = selectedVariant.value.trim();
//       let match = palletValue.match(/^(\d+)/);
//       if (match) {
//         return parseInt(match[1], 10);
//       } else {
//         console.warn(
//           "Could not extract number of pallets from value:",
//           palletValue
//         );
//         return 1;
//       }
//     }
//     console.error("No variant selected");
//     return 1;
//   };

//   const getUnitsPerPallet = () => {
//     const selectedVariant = document.querySelector(
//       ".product-variant__input:checked"
//     );
//     return selectedVariant
//       ? selectedVariant.getAttribute("data-units-per-pallet") || 1
//       : 1;
//   };

//   const updatePriceAndSetQuantity = () => {
//     quantityButtons.style.opacity = 0;
//     const numberOfPallets = getNumberOfPallets();
//     const unitsPerPallet = getUnitsPerPallet();
//     const priceText = document
//       .querySelector(".product-price--original")
//       .textContent.trim();
//     const cleanedPrice = parseFloat(
//       priceText.replace(/[^\d,.-]/g, "").replace(",", ".")
//     );

//     const pricePerUnit = parseFloat(cleanedPrice);
//     const unitsPerPalletTable = document.querySelector(".units-per-pallet");
//     const noOfPalletsTable = document.querySelector(".no-of-pallets");

//     if (isNaN(pricePerUnit)) {
//       console.error("Invalid price format:", priceElement.textContent);
//       return;
//     }

//     console.log("Number of Pallets:", numberOfPallets);
//     console.log("Units Per Pallet:", unitsPerPallet);
//     console.log("Price Per Unit:", pricePerUnit);

//     noOfPalletsTable.innerHTML = numberOfPallets;
//     unitsPerPalletTable.innerHTML = unitsPerPallet;

//     // Calculate total quantity and update UI
//     const totalQuantity = numberOfPallets * unitsPerPallet;
//     qty.value = totalQuantity;
//     qty.setAttribute("readonly", true);
//     qty.setAttribute("min", totalQuantity);
//     qty.setAttribute("max", totalQuantity);
//     qtyMinus.setAttribute("disabled", "true");
//     qtyPlus.setAttribute("disabled", "true");

//     // Calculate total price and update UI
//     const totalPrice = (
//       numberOfPallets *
//       unitsPerPallet *
//       pricePerUnit
//     ).toFixed(2);
//     console.log("Total Price Calculated:", totalPrice);

//     const totalPriceElement = document.querySelector(
//       "[data-product-total-price]"
//     );

//     totalPriceElement.innerHTML = "€" + totalPrice.replace(".", ",");
//   };

//   variantInputs.forEach((input) => {
//     input.addEventListener("change", () => {
//       setTimeout(updatePriceAndSetQuantity, 10);
//     });
//   });

//   updatePriceAndSetQuantity();
// });

class PalletsPicker extends HTMLElement {
  constructor() {
    super();
    this.supportsByBale = this.hasAttribute("data-supports-by-bale");
  }

  connectedCallback() {
    const changeItemsInCart = document.querySelector("[data-delivery-method-change-items-in-cart]");
    if(this.supportsByBale) {
      document.addEventListener("delivery-method-changed", this.onDeliveryMethodChanged.bind(this));

      const deliveryMethod = localStorage.getItem("shippingMethod") || "free";
      if(deliveryMethod == 'free') {
        this.showByPallet();
      }
      else {
        this.showByBale();
      }
    }
  }

  updateElements(newHtml) {
    this.innerHTML = newHtml;
  }

  onDeliveryMethodChanged(e) {
    const deliveryMethod = e.detail.newDeliveryMethod;
    const changedFromCart = e.detail.changedFromCart;

    if(!deliveryMethod) return;

    this.deliveryMethod = deliveryMethod;

    if(deliveryMethod == 'free') {
      this.showByPallet();
    }
    else {
      this.showByBale();
    }
  }

  showByPallet() {
    const productActionsPrice = document.querySelector(".product-actions__price");
    const palletWrapper = this.closest(".product-variants").querySelector("pallets-picker").closest(".product-variant__container");
    const quantitySelector = document.querySelector(".product-quantity-wrapper");
    const totalPrice = document.querySelector(".product-total-price");
    const freeShipping = document.querySelector(".free-shipping");
    const byPalletOption = document.querySelector("[data-by-pallet-option]");
    const tab = document.querySelector(".product-tabs").querySelector("#prices-and-options-tab-btn");

    productActionsPrice.style.display = "none";
    palletWrapper.style = "";
    quantitySelector.style.display = "none";
    quantitySelector.querySelector('product-quantity').setAttribute("style", "display: none;");
    totalPrice.style = "";
    freeShipping.style = "";
    tab.style = "";
    byPalletOption.click();
  }

  showByBale() {
    const productActionsPrice = document.querySelector(".product-actions__price");
    const palletWrapper = this.closest(".product-variants").querySelector("pallets-picker").closest(".product-variant__container");
    const quantitySelector = document.querySelector(".product-quantity-wrapper");
    const totalPrice = document.querySelector(".product-total-price");
    const freeShipping = document.querySelector(".free-shipping");
    const byBaleOption = document.querySelector("[data-by-bale-option]");
    const tab = document.querySelector(".product-tabs").querySelector("#prices-and-options-tab-btn");

    productActionsPrice.style = "";
    palletWrapper.style.display = "none";
    quantitySelector.style = "";
    setTimeout(() => {
      quantitySelector.querySelector('product-quantity').setAttribute("style", "display: flex !important;");
    }, 500);
    totalPrice.style.display = "none";
    freeShipping.style.display = "none";
    tab.style.display = "none";
    byBaleOption.click();
  }
}
customElements.define("pallets-picker", PalletsPicker);

document.addEventListener("DOMContentLoaded", () => {
  const tables = document.querySelectorAll("pallets-picker ");

  function initShipping() {
    const localDeliveries = Array.from(
      document.querySelectorAll(`[data-is-pickup="true"]`)
    );
    const shippings = Array.from(
      document.querySelectorAll(`[data-is-pickup="false"]`)
    );
    const mainBox = document.querySelector(
      `.product-variant__container:has([data-is-pickup])`
    );
    const newContent = `
    <span class="product-variant__name text-size--large">Home delivery</span>
    <div class="product-variant__container--box">
      ${shippings.map((el) => el.outerHTML).join("")}
    </div>
    <span class="product-variant__name text-size--large">Local pickups</span>
    <div class="product-variant__container--box">
      ${localDeliveries.map((el) => el.outerHTML).join("")}
    </div>
    `;

    if(mainBox) mainBox.innerHTML = newContent;
  }
  initShipping();
});

function triggerLabel(id) {
  const label = document.querySelector(`label[for="${id}"]`);
  label.click();
}
